export const collection = 'industry_overview';
export const pageName = {
  about: 'About Aus Meat',
  food: 'Food Safety',
  marketing: 'Marketing Research & Development',
};
